// extracted by mini-css-extract-plugin
export var blushIllustration = "bw_dR";
export var button = "bw_bP";
export var cardHeadline = "bw_dS";
export var cardRoot = "bw_dQ";
export var wrapper = "bw_bM";